import { render, staticRenderFns } from "./pageDistributionGoodsModule.vue?vue&type=template&id=dcf845a0"
import script from "./pageDistributionGoodsModule.vue?vue&type=script&lang=js"
export * from "./pageDistributionGoodsModule.vue?vue&type=script&lang=js"
import style0 from "./pageDistributionGoodsModule.vue?vue&type=style&index=0&id=dcf845a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports